import { Link } from 'react-router-dom';
import { comics, newComicIds } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestSection() {
  const latestComics = newComicIds
    .map((id) => comics.find((c) => c.id === id))
    .filter(Boolean) as NonNullable<ReturnType<typeof comics.find>>[];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新更新
          </h2>
          <Link
            to="/category/korean"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            全部作品 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}